import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {LabelXSmallBold} from '@travel-frontend/ui-components';

type Props = {
  size: 'small' | 'medium';
};

export const Chip = styled(LabelXSmallBold)<Props>(
  ({theme, size}) => css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${theme.colors.contentInversePrimary};
    background-color: #013e7a;
    /* stylelint-disable-next-line invia/use-spacing-tokens */
    padding: ${{
      small: '2px 8px 2px 4px',
      medium: '5px 8px 5px 5px',
    }[size]};
    border-radius: 16px;
    ${theme.elevations.small};
  `
);
